import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { AppService } from '../../app.service';
import { Location } from '@angular/common';
import { UtilsService } from '../../shared/utils.service';
import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { SitesSelectorComponent } from '../../shared/sites-selector/sites-selector.component';
import { NetworkedUsersSelectorComponent } from '../../shared/networked-users-selector/networked-users-selector.component';
import { NetworkedAccountsSelectorComponent } from '../../shared/networked-accounts-selector/networked-accounts-selector.component';
import { NetworkedEmployeesSelectorComponent } from '../../shared/networked-employees-selector/networked-employees-selector.component';

@Component({
  selector: 'app-pandemic-records-filter',
  templateUrl: './pandemic-records-filter.component.html',
  styleUrls: ['./pandemic-records-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PandemicRecordsFilterComponent implements OnInit {
  dataSource = new PandemicRecordsFilterDataSource(); // No API calls needed
  faHardHat = faHardHat;

  constructor(
    private app: AppService,
    public location: Location,
    public utils: UtilsService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PandemicRecordsFilterComponent>
  ) // private api: ApiRequestService
  {
    // set a default site selection of nothing if no selected values are passed through
    if (typeof this.data['selected_site_ids'] === 'undefined') {
      this.data['selected_site_ids'] = [];
    }

    // set a default contractor selection of nothing if no selected values are passed through
    if (typeof this.data['selected_contractor_ids'] === 'undefined') {
      this.data['selected_contractor_ids'] = [];
    }

    // set a default user of nothing if no values are passed through
    if (typeof this.data['selected_user_ids'] === 'undefined') {
      this.data['selected_user_ids'] = [];
    }

    // set a default user of nothing if no values are passed through
    if (typeof this.data['selected_employee_ids'] === 'undefined') {
      this.data['selected_employee_ids'] = [];
    }

    // set a default pandemic date of nothing if no values are passed through
    if (typeof this.data['filter_date_range'] === 'undefined') {
      this.data['filter_date_range'] = [];
    }
  }

  ngOnInit() {
    this.dataSource.selected_site_ids = this.data['selected_site_ids'];
    this.dataSource.selected_contractor_ids = this.data[
      'selected_contractor_ids'
    ];
    this.dataSource.selected_user_ids = this.data['selected_user_ids'];
    this.dataSource.selected_employee_ids = this.data['selected_employee_ids'];
    this.dataSource.filter_date_range = this.data['filter_date_range'];
  }

  getOutputDateRange($event) {
    this.dataSource.filter_date_range = $event;
  }

  onSelectSites() {
    this.utils.showComponentDialog(
      SitesSelectorComponent,
      {
        selected: this.dataSource.selected_site_ids,
        multiple: true
      },
      {
        width: '1024px'
      },
      (results) => {
        if (typeof results !== 'undefined') {
          this.dataSource.selected_site_ids = results;
        }
      }
    );
  }

  onSelectUsers() {
    this.utils.showComponentDialog(
      NetworkedUsersSelectorComponent,
      {
        selected: this.dataSource.selected_user_ids,
        multiple: true,
        selectedAccountId: this.dataSource.selected_contractor_ids.length
          ? this.dataSource.selected_contractor_ids[0]
          : 0,
        visitors_from_all_sites: true
      },
      {
        width: '1024px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.dataSource.selected_user_ids = results;
      }
    );
  }

  onSelectContractors() {
    this.utils.showComponentDialog(
      NetworkedAccountsSelectorComponent,
      {
        selected: this.dataSource.selected_contractor_ids,
        multiple: true
      },
      {
        width: '1024px'
      },
      (results) => {
        if (typeof results !== 'undefined') {
          this.dataSource.selected_contractor_ids = results;
        }
      }
    );
  }

  onSelectEmployees() {
    this.utils.showComponentDialog(
      NetworkedEmployeesSelectorComponent,
      {
        selected: this.dataSource.selected_employee_ids,
        multiple: true
      },
      {
        width: '1024px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.dataSource.selected_employee_ids = results;
      }
    );
  }

  onClearAndClose() {
    this.dataSource.selected_site_ids = [];
    this.dataSource.selected_contractor_ids = [];
    this.dataSource.selected_user_ids = [];
    this.dataSource.selected_employee_ids = [];
    this.dataSource.filter_date_range = [];

    this.onSaveAndClose();
  }

  onSaveAndClose() {
    let response: any;

    response = {
      site_ids: this.dataSource.selected_site_ids,
      contractor_ids: this.dataSource.selected_contractor_ids,
      user_ids: this.dataSource.selected_user_ids,
      employee_ids: this.dataSource.selected_employee_ids,
      pandemic_date_range: this.dataSource.filter_date_range
    };

    this.dialogRef.close(response);
  }
}

/**
 * the data source class should contain everything needed to get data for the feature.
 */
export class PandemicRecordsFilterDataSource {
  selected_site_ids: number[] = [];
  selected_contractor_ids: number[] = [];
  selected_user_ids: number[] = [];
  selected_employee_ids: number[] = [];
  filter_date_range: Date[] = [];

  constructor() {
    this.selected_site_ids = [];
    this.selected_contractor_ids = [];
    this.selected_user_ids = [];
    this.selected_employee_ids = [];
    this.filter_date_range = [];
  }
}
